const ROLE_LABELS: Record<string, string> = {
  admin: 'Administrador',
  reviewer: 'Revisor',
  normal: 'Proveedor',
};

/** Human-readable Spanish label for a `user_role` value. */
export function roleLabel(role: string | null | undefined): string {
  if (!role) return '';
  return ROLE_LABELS[role] || role;
}
